import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useMemo, useState } from 'react';
const defaultValue = {
    open: false,
    message: '',
    severityValue: '',
    setMessage: () => { },
    setSeverityValue: () => { },
    setToastState: () => { }
};
const ToastContext = React.createContext(defaultValue);
export const ToastContextProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [msg, setMsg] = useState('');
    const [severityValue, setSeverityValue] = useState('');
    const stateHandler = (v) => {
        setIsOpen(v);
    };
    const contextValue = useMemo(() => ({
        open: isOpen,
        message: msg,
        severityValue: severityValue,
        setSeverityValue: setSeverityValue,
        setMessage: setMsg,
        setToastState: stateHandler
    }), [isOpen, msg, severityValue]);
    return (_jsx(ToastContext.Provider, { value: contextValue, children: children }));
};
export const useToastContext = () => {
    return useContext(ToastContext);
};
export default ToastContext;
